webpackJsonp([42824396062603],{

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(98);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 4: Improve the User Experience'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to improve the user experience for pagination.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'pagination.4' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Why is this happening?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Each time we click a pagination link, we change the URL in the browser. This change causes the application to re-render. When the Feed component re-renders, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connect'
	      ),
	      ' call retrives the page of data associated with the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'page'
	      ),
	      ' query parameter in the URL. Since that data hasn\'t been fetched yet, it passes a collection to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' that has no data, and since ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' is rendering whatever it receives as a prop, it renders nothing.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'How do we fix this?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To provide a better experience, we need to ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'hold onto the previous tweets'
	      ),
	      ' until the new page has been fetched from the API.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do that, we\'re going to change our rendering strategy so that instead of using the Feed\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'props'
	      ),
	      ' to determine what gets rendered, we\'re going to use Feed\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ', and manage which page to render ourselves.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Update Feed'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Start by providing some initial state and a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'componentWillRecieveProps()'
	      ),
	      ' method to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component that look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Feed.js\n        ...\n        getInitialState() {\n          const { tweets } = this.props;\n\n          return {\n            tweets: tweets,\n            nextTweets: tweets\n          };\n        },\n\n        componentWillReceiveProps(nextProps) {\n          const nextTweets = nextProps.tweets;\n\n          if (nextTweets.state === PayloadStates.FETCHING) {\n            this.setState({\n              nextTweets: nextTweets,\n              isFetching: true\n            });\n          } else {\n            this.setState({\n              tweets: nextTweets,\n              nextTweets: nextTweets,\n              isFetching: false\n            });\n          }\n        },\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Feed.js\n        ...\n        constructor(props) {\n          super(props);\n          this.state = {\n            tweets: props.tweets,\n            nextTweets: props.tweets\n          };\n        }\n\n        componentWillReceiveProps(nextProps) {\n          const nextTweets = nextProps.tweets;\n\n          if (nextTweets.state === PayloadStates.FETCHING) {\n            this.setState({\n              nextTweets: nextTweets,\n              isFetching: true\n            });\n          } else {\n            this.setState({\n              tweets: nextTweets,\n              nextTweets: nextTweets,\n              isFetching: false\n            });\n          }\n        }\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Feed.js\n        ...\n        constructor(props) {\n          super(props);\n          this.state = {\n            tweets: props.tweets,\n            nextTweets: props.tweets\n          };\n        }\n\n        componentWillReceiveProps(nextProps) {\n          const nextTweets = nextProps.tweets;\n\n          if (nextTweets.state === PayloadStates.FETCHING) {\n            this.setState({\n              nextTweets: nextTweets,\n              isFetching: true\n            });\n          } else {\n            this.setState({\n              tweets: nextTweets,\n              nextTweets: nextTweets,\n              isFetching: false\n            });\n          }\n        }\n        ...\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/components/Feed.js\n      render() {\n        const { tweets, nextTweets } = this.state;\n        const currentPage = nextTweets.query.pagination.page;\n        const paginationLinks = [];\n\n        // check if we\'re fetching the next page of tweets\n        const isFetchingNextTweets = nextTweets.state === PayloadStates.FETCHING;\n\n        if (tweets.state === PayloadStates.FETCHING) {\n          return (\n            <div className="feed">\n              <h2 className="title">\n                Feed\n              </h2>\n              <div className="loader"/>\n            </div>\n          );\n        }\n\n        // calculate the number of pagination links from our metadata, then\n        // generate an array of pagination links\n        const numberOfPages = Math.ceil(tweets.meta.totalCount / tweets.meta.perPage);\n        for (let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++) {\n          paginationLinks.push(this.renderPaginationLink(pageNumber, currentPage));\n        }\n\n        return (\n          <div className="feed">\n            <h2 className="title">\n              Feed\n            </h2>\n            <ul className={`media-list tweets ${isFetchingNextTweets ? \'transition\' : \'\'}`}>\n              {tweets.data.map(this.renderTweet)}\n            </ul>\n            <nav>\n              <ul className="pagination">\n                {paginationLinks}\n              </ul>\n            </nav>\n          </div>\n        );\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'ve created a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' variable called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets'
	      ),
	      ', and updated our',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method so that we render the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' version of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets'
	      ),
	      ' instead of what we get from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'props'
	      ),
	      '. Then we\'ve added a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'componentWillReceiveProps()'
	      ),
	      ' method that will allow us to inspect the incoming data from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'props'
	      ),
	      ' and decide whether or not to render it.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the new page ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'is'
	      ),
	      ' being fetched, then we continue to render the previous page, but add the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'transition'
	      ),
	      ' class to the rendered list, which will provide a visual cue to the user that the new page is being fetched.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the data is ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'not'
	      ),
	      ' being fetched, then we update our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' variable to reflect the new page.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you\'d like to see a more advanced example of pagination, see the ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/examples/pagination/' },
	          'pagination example'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Feed.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import { Link } from \'react-router\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import Tweet from \'./Tweet\';\n\n        export default connect(function(getState, props) {\n          const { location } = props;\n\n          return {\n            tweets: getState(\'tweet.find\', {\n              pagination: {\n                sort: \'createdAt DESC\',\n                page: location.query.page || \'1\'\n              }\n            })\n          };\n        })(\n        createReactClass({\n          displayName: \'Feed\',\n\n          propTypes: {\n            tweets: PropTypes.object.isRequired\n          },\n\n          getInitialState() {\n            const { tweets } = this.props;\n\n            return {\n              tweets: tweets,\n              nextTweets: tweets\n            };\n          },\n\n          componentWillReceiveProps(nextProps) {\n            const nextTweets = nextProps.tweets;\n\n            if (nextTweets.state === PayloadStates.FETCHING) {\n              this.setState({\n                nextTweets: nextTweets,\n                isFetching: true\n              });\n            } else {\n              this.setState({\n                tweets: nextTweets,\n                nextTweets: nextTweets,\n                isFetching: false\n              });\n            }\n          },\n\n          renderTweet(tweet) {\n            return (\n              <Tweet key={tweet.id} tweet={tweet} />\n            );\n          },\n\n          renderPaginationLink(page, currentPage) {\n            return (\n              <li key={page} className={currentPage === String(page) ? \'active\' : \'\'}>\n                <Link to={{ pathname: \'/\', query: { page: page } }}>\n                  {page}\n                </Link>\n              </li>\n            );\n          },\n\n          render() {\n            const { tweets, nextTweets } = this.state;\n            const currentPage = nextTweets.query.pagination.page;\n            const paginationLinks = [];\n\n            if (tweets.state === PayloadStates.FETCHING) {\n              return (\n                <div className="feed">\n                  <h2 className="title">\n                    Feed\n                  </h2>\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            // check if we\'re fetching the next page of tweets\n            const isFetchingNextTweets = nextTweets.state === PayloadStates.FETCHING;\n\n            // calculate the number of pagination links from our metadata, then\n            // generate an array of pagination links\n            const numberOfPages = Math.ceil(tweets.meta.totalCount / tweets.meta.perPage);\n            for (let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++) {\n              paginationLinks.push(this.renderPaginationLink(pageNumber, currentPage));\n            }\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className={`media-list tweets ${isFetchingNextTweets ? \'transition\' : \'\'}`}>\n                  {tweets.data.map(this.renderTweet)}\n                </ul>\n                <nav>\n                  <ul className="pagination">\n                    {paginationLinks}\n                  </ul>\n                </nav>\n              </div>\n            );\n          }\n\n        })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import { Link } from \'react-router\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import Tweet from \'./Tweet\';\n\n        class Feed extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.state = {\n              tweets: props.tweets,\n              nextTweets: props.tweets\n            };\n          }\n\n          componentWillReceiveProps(nextProps) {\n            const nextTweets = nextProps.tweets;\n\n            if (nextTweets.state === PayloadStates.FETCHING) {\n              this.setState({\n                nextTweets: nextTweets,\n                isFetching: true\n              });\n            } else {\n              this.setState({\n                tweets: nextTweets,\n                nextTweets: nextTweets,\n                isFetching: false\n              });\n            }\n          }\n\n          renderTweet(tweet) {\n            return (\n              <Tweet key={tweet.id} tweet={tweet} />\n            );\n          }\n\n          renderPaginationLink(page, currentPage) {\n            return (\n              <li key={page} className={currentPage === String(page) ? \'active\' : \'\'}>\n                <Link to={{ pathname: \'/\', query: { page: page } }}>\n                  {page}\n                </Link>\n              </li>\n            );\n          }\n\n          render() {\n            const { tweets, nextTweets } = this.state;\n            const currentPage = nextTweets.query.pagination.page;\n            const paginationLinks = [];\n\n            // check if we\'re fetching the next page of tweets\n            const isFetchingNextTweets = nextTweets.state === PayloadStates.FETCHING;\n\n            if (tweets.state === PayloadStates.FETCHING) {\n              return (\n                <div className="feed">\n                  <h2 className="title">\n                    Feed\n                  </h2>\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            // calculate the number of pagination links from our metadata, then\n            // generate an array of pagination links\n            const numberOfPages = Math.ceil(tweets.meta.totalCount / tweets.meta.perPage);\n            for (let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++) {\n              paginationLinks.push(this.renderPaginationLink(pageNumber, currentPage));\n            }\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className={`media-list tweets ${isFetchingNextTweets ? \'transition\' : \'\'}`}>\n                  {tweets.data.map(this.renderTweet)}\n                </ul>\n                <nav>\n                  <ul className="pagination">\n                    {paginationLinks}\n                  </ul>\n                </nav>\n              </div>\n            );\n          }\n\n        }\n\n        Feed.propTypes = {\n          tweets: PropTypes.object.isRequired\n        };\n\n        export default connect(function(getState, props) {\n          const { location } = props;\n\n          return {\n            tweets: getState(\'tweet.find\', {\n              pagination: {\n                sort: \'createdAt DESC\',\n                page: location.query.page || \'1\'\n              }\n            })\n          };\n        })(Feed);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import { Link } from \'react-router\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import Tweet from \'./Tweet\';\n\n        @connect(function(getState, props) {\n          const { location } = props;\n\n          return {\n            tweets: getState(\'tweet.find\', {\n              pagination: {\n                sort: \'createdAt DESC\',\n                page: location.query.page || \'1\'\n              }\n            })\n          };\n        })\n        class Feed extends React.Component {\n\n          static propTypes = {\n            tweets: PropTypes.object.isRequired\n          };\n\n          constructor(props) {\n            super(props);\n            this.state = {\n              tweets: props.tweets,\n              nextTweets: props.tweets\n            };\n          }\n\n          componentWillReceiveProps(nextProps) {\n            const nextTweets = nextProps.tweets;\n\n            if (nextTweets.state === PayloadStates.FETCHING) {\n              this.setState({\n                nextTweets: nextTweets,\n                isFetching: true\n              });\n            } else {\n              this.setState({\n                tweets: nextTweets,\n                nextTweets: nextTweets,\n                isFetching: false\n              });\n            }\n          }\n\n          renderTweet(tweet) {\n            return (\n              <Tweet key={tweet.id} tweet={tweet} />\n            );\n          }\n\n          renderPaginationLink(page, currentPage) {\n            return (\n              <li key={page} className={currentPage === String(page) ? \'active\' : \'\'}>\n                <Link to={{ pathname: \'/\', query: { page: page } }}>\n                  {page}\n                </Link>\n              </li>\n            );\n          }\n\n          render() {\n            const { tweets, nextTweets } = this.state;\n            const currentPage = nextTweets.query.pagination.page;\n            const paginationLinks = [];\n\n            // check if we\'re fetching the next page of tweets\n            const isFetchingNextTweets = nextTweets.state === PayloadStates.FETCHING;\n\n            if (tweets.state === PayloadStates.FETCHING) {\n              return (\n                <div className="feed">\n                  <h2 className="title">\n                    Feed\n                  </h2>\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            // calculate the number of pagination links from our metadata, then\n            // generate an array of pagination links\n            const numberOfPages = Math.ceil(tweets.meta.totalCount / tweets.meta.perPage);\n            for (let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++) {\n              paginationLinks.push(this.renderPaginationLink(pageNumber, currentPage));\n            }\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className={`media-list tweets ${isFetchingNextTweets ? \'transition\' : \'\'}`}>\n                  {tweets.data.map(this.renderTweet)}\n                </ul>\n                <nav>\n                  <ul className="pagination">\n                    {paginationLinks}\n                  </ul>\n                </nav>\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next section we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../infinite-scrolling/overview/' },
	        'replace our pagination links with infinite scrolling behavior'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-pagination-step-4-js-b8a01785c1ccb3ce339a.js